import React, { useMemo, useState, useEffect, useRef } from 'react'
import { Modal, Form, Header, Icon, Button, Input, Checkbox, Table } from "semantic-ui-react"

import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import ModInfo from "react-lib/apps/common/ModInfo";
import { useIntl } from "react-intl";

const ModalSetKeyboardShortcuts = (props) => {
  const intl = useIntl();
  const [selectedRow, setSelectedRow] = useState<any>({
    data: {},
    field: ""
  })
  const [targetMouseOver, setTargetMouseOver] = useState<any>({
    data: {},
    field: ""
  })
  const [errorMessage, setErrorMessage] = useState<string>("")
  const [errorMessageModal, setErrorMessageModal] = useState<string>("")
  const [keyboardShortcutList, setKeyboardShortcutList] = useState<any[]>([])
  const [openModAddShortcut, setOpenModAddShortcut] = useState<boolean>(false)
  const [checkedShortcut, setCheckedShortcut] = useState<any[]>([])
  const [openModConfirm, setOpenModConfirm] = useState<boolean>(false)
  const [openModInfo, setOpenModInfo] = useState(false)

  const inputRef = useRef<any>()
  const shortcutKeyRef = useRef<any>()
  const clinicalFindingRef = useRef<any>()
  const isHoverIcon = useRef<any>(false)

  useEffect(() => {
    if (props.open) {
      handleSetKeyboardShortcutList(props.keyboardShortcut)
    }
  }, [props.open])


  const handleSetKeyboardShortcutList = (data) => {
    const setData = data.map((list) => {
      const [key] = Object.keys(list)
      console.log("keyboardshortlist:", key, Object.keys(list))
      return {
        id: list['id'],
        key: list["key"],
        value: list["other_clinical_finding"]
      }
    })
    setKeyboardShortcutList(setData)
  }

  const handleDoubleClickRow = (data, field) => {
    setSelectedRow({
      data,
      field
    })
    setTimeout(() => {
      inputRef.current.focus()
      inputRef.current.value = data[field]
    });
  }

  const handleMouseOver = (data, field) => {
    setTargetMouseOver({
      data,
      field
    })
  }

  const handleOnBlurInput = (ev = null) => {

    if (isHoverIcon.current && ev) {
      return
    }
    if (selectedRow.field === "key") {
      const findKey = keyboardShortcutList.find((data) =>
        data.key === inputRef.current.value && data.key !== selectedRow.data.key)
      if (findKey) {
        setErrorMessage("คีย์นี้มีการใช้งานอยู่แล้ว กรุณาเลือกใช้คีย์อื่น")
        return
      }
    }
    const changeValue = keyboardShortcutList.map((data) => {
      if (data.key === selectedRow.data.key) {
        return {
          ...data,
          [selectedRow.field]: inputRef.current.value
        }
      } else return data
    })
    setKeyboardShortcutList(changeValue)
    setSelectedRow({
      data: {},
      field: ""
    })
    setErrorMessage("")

  }

  const handleKeyDownInput = (ev, field) => {
    if (field === "key") {
      ev.preventDefault()
      if (ev.keyCode >= 112 && ev.keyCode <= 123) {
        inputRef.current.value = ev.key
        if (errorMessage) {
          setErrorMessage("")
        }
      } else {
        setErrorMessage("กรุณาเลือกใช้คีย์ระหว่าง F1 - F12")
      }

    }
    if (ev.key === "Enter") {

      handleOnBlurInput()
    }
  }

  const handleKeyDownInputModal = (ev) => {
    ev.preventDefault()
    if (ev.keyCode >= 112 && ev.keyCode <= 123) {
      shortcutKeyRef.current.value = ev.key
      if (errorMessage) {
        setErrorMessageModal("")
      }
    } else {
      setErrorMessageModal("กรุณาเลือกใช้คีย์ระหว่าง F1 - F12")
    }

  }

  const handleCheckShortcut = (data, checked) => {
    let cloneArray = [...checkedShortcut]
    if (!checked) {
      cloneArray = cloneArray.filter((check) => check !== data.key)
    } else {
      cloneArray.push(data.key)
    }
    setCheckedShortcut(cloneArray)
  }

  const handleConfirmRemoveShortcut = () => {
    const removeData = keyboardShortcutList.filter((shortcut) => !checkedShortcut.includes(shortcut.key))

    // remove keyboard shortcut key in database
    const removeFromDB = keyboardShortcutList.filter((shortcut) => checkedShortcut.includes(shortcut.key) && shortcut.id)
    props.onDelete(removeFromDB)

    setKeyboardShortcutList(removeData)
    setOpenModConfirm(false)
  }

  const handleRemoveShortcut = () => {
    if (!checkedShortcut.length) {
      setOpenModInfo(true)
    } else {
      setOpenModConfirm(true)
    }
  }

  const handleAddClinicalFinding = () => {
    const findKey = keyboardShortcutList.find((data) =>
      data.key === shortcutKeyRef.current.value)
    if (findKey) {
      setErrorMessageModal("คีย์นี้มีการใช้งานอยู่แล้ว กรุณาเลือกใช้คีย์อื่น")
      return
    }

    if (!shortcutKeyRef.current.value.trim()) {
      setErrorMessageModal("กรุณาระบุค่าในช่อง Key")
      return
    }

    if (!clinicalFindingRef.current.value.trim()) {
      setErrorMessageModal("กรุณาระบุค่าในช่อง Message")
      return
    }

    const listData = [...keyboardShortcutList, {
      key: shortcutKeyRef.current.value,
      value: clinicalFindingRef.current.value
    }]

    setKeyboardShortcutList(listData)
    setErrorMessageModal("")
    setOpenModAddShortcut(false)
  }

  const handleOpenModalAddClinicalFinding = () => {
    setOpenModAddShortcut(true)
    setTimeout(() => {
      shortcutKeyRef.current.focus()
    });
  }


  const handleSaveClinicalFinding = () => {
    let keyShortcut: any = {}
    const listData = keyboardShortcutList.forEach((list) => 
      keyShortcut[list.key] = {id:list.id, value:list.value }
      )

    clearDataModal()
    props.onSave?.(keyShortcut)
  }

  const handleCancelClinicalFinding = () => {
    clearDataModal()
    props.onCancel?.()
  }

  const clearDataModal = () => {
    setErrorMessage("")
    setKeyboardShortcutList([])
    setCheckedShortcut([])
  }


  const createTableCell = (list, field) => {

    return <Table.Cell
      onDoubleClick={(ev) => {
        handleDoubleClickRow(list, field)
      }}
      onMouseOver={(ev) => {
        handleMouseOver(list, field)
      }}
      onMouseLeave={(ev) => {
        handleMouseOver({}, "")
      }}
      style={{ width: field === "key" ? "200px" : "", }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ width: "30px", paddingTop: "1px" }}>
          {
            targetMouseOver.field === field && targetMouseOver.data[field] === list[field] ?
              <Icon name="pencil" color="yellow" /> : null
          }
        </div>
        {
          selectedRow.field === field && selectedRow.data[field] === list[field] ?
            <Input
              className="keyboard-shortcut-input"
              ref={(instance) => {
                if (instance) {
                  inputRef.current = instance.inputRef.current
                }
              }}
              onBlur={handleOnBlurInput}
              onKeyDown={(ev) => handleKeyDownInput(ev, field)}
              style={{ width: field === "key" ? "" : "100%" }}
              icon={field === "value" ? {} : {
                name: 'sync alternate',
                circular: true,
                link: true,
                onClick: () => {
                  inputRef.current.value = selectedRow.data.key
                  inputRef.current.focus()
                },
                onMouseOver: () => {
                  isHoverIcon.current = true
                },
                onMouseLeave: () => {
                  isHoverIcon.current = false
                }
              }}

            /> :
            <div style={{overflow:"hidden", whiteSpace:"nowrap", textOverflow:"ellipsis", maxWidth: "450px"}}>
              {list[field]}
            </div>
        }
      </div>
    </Table.Cell>
  }

  const listTableRow = useMemo(() => {
    return keyboardShortcutList.map((list) =>
      <Table.Row>
        <Table.Cell
          textAlign="center"
          style={{ backgroundColor: "transparent", width: "55px" }}>
          <Checkbox
            style={{ transform: "scale(1.5)" }}
            checked={checkedShortcut.includes(list.key)}
            onChange={(ev, { checked }) => handleCheckShortcut(list, checked)} />
        </Table.Cell>

        {createTableCell(list, "key")}

        {createTableCell(list, "value")}

      </Table.Row >)
  }
    , [keyboardShortcutList, selectedRow, targetMouseOver, checkedShortcut])

  return (
    <Modal
      open={props.open}
      size="small"
      onClose={() => {
        clearDataModal()
        props.onClose?.()
      }}
      closeOnDimmerClick={false}
      closeIcon={true}
    >
      <Modal.Header>
        <Form >
          <Form.Field>
            <Header as="h3" style={{ paddingRight: "5px", fontWeight: "bold" }}>Conditional formatting clinical finding terms </Header>
          </Form.Field>
        </Form>
      </Modal.Header>
      <Modal.Description style={{ textAlign: "center" }}>
        <Form>
          <Form.Group inline style={{ padding: "15px", paddingBottom: "0" }}>
            <Form.Field>
              <Button icon labelPosition='left' color="yellow" onClick={handleOpenModalAddClinicalFinding}>
                <Icon name='file text outline' />
                  New
              </Button>
            </Form.Field>
            <Form.Field>
              <Button icon labelPosition='left' color="red" onClick={handleRemoveShortcut}>
                <Icon name='trash alternate outline' />
                  Delete
              </Button>
            </Form.Field>
          </Form.Group>
          <p style={{ borderBottom: "1px solid rgba(34,36,38,.15)" }} />
          <Form.Group style={{
            display: "flex", justifyContent: "center"
          }}>
            <Table definition celled selectable style={{ width: "95%" }}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell />
                  <Table.HeaderCell>Key</Table.HeaderCell>
                  <Table.HeaderCell>Message</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {listTableRow}
              </Table.Body>
            </Table>

          </Form.Group>

          {!keyboardShortcutList[0] &&
            <>
              <div>Message Not Found</div>
              <br />
            </>
          }
        </Form>
      </Modal.Description>
      <p style={{ borderBottom: "1px solid rgba(34,36,38,.15)" }} />
      <Form>
        <Form.Group inline style={{ padding: "15px", paddingTop: "0px" }}>
          <Form.Field width={12}>
            <ErrorMessage error={errorMessage} />
          </Form.Field>
          <Form.Field>
            <Button
              color="red"
              onClick={handleCancelClinicalFinding}
            >
              Cancel
        </Button>
          </Form.Field>
          <Form.Field>
            <Button
              color="green"
              onClick={handleSaveClinicalFinding}
            >
              Save
        </Button>
          </Form.Field>
        </Form.Group>

      </Form>
      <ModInfo
        open={openModAddShortcut}
        color="blue"
        titleName="Message"
        onClose={() => setOpenModAddShortcut(false)}
        onApprove={handleAddClinicalFinding}
        btnText="OK"
      >
        <ErrorMessage error={errorMessageModal} />
        <Form style={{ textAlign: "left" }}>
          <Form.Field width={16}>
            Key
            </Form.Field>
          <Form.Field>
            <Input
              ref={(instance) => {
                if (instance) {
                  shortcutKeyRef.current = instance.inputRef.current
                }
              }}
              fluid
              onKeyDown={handleKeyDownInputModal}
            />
          </Form.Field>

          <Form.Field width={16}>
            Message
            </Form.Field>
          <Form.Field >
            <Input
              ref={(instance) => {
                if (instance) {
                  clinicalFindingRef.current = instance.inputRef.current
                }
              }}
              fluid />
          </Form.Field>
        </Form>
      </ModInfo>
      <ModConfirm
        openModal={openModConfirm}
        titleName={intl.formatMessage({ id: "ต้องการลบรายการนี้หรือไม่" })}
        onApprove={handleConfirmRemoveShortcut}
        onDeny={() => setOpenModConfirm(false)}
      />
      <ModInfo
        open={openModInfo}
        titleName={intl.formatMessage({ id: "กรุณาเลือกรายการ" })}
        color="yellow"
        onApprove={() => setOpenModInfo(false)}
      />
    </Modal >
  )
}

export default ModalSetKeyboardShortcuts